import { AlLocation } from '@al/core';
import { AlIdentityResolutionGuard, AlRedirectorComponent } from '@al/ng-navigation-components';
import { ɵbypassSanitizationTrustResourceUrl } from '@angular/core';
import {
    RouterModule,
    Routes,
    UrlSegment
} from '@angular/router';
import { GeneralErrorComponent } from "./general-error/general-error.component";
import { HomeRouteComponent } from "./home-route/home-route.component";
import { InitiatePasswordResetComponent } from "./initiate-password-reset/initiate-password-reset.component";
import { LoginComponent } from "./login";
import { LogoutComponent } from "./logout";
import { PasswordResetComponent } from "./password-reset/password-reset.component";
import { ResetConfirmationComponent } from "./reset-confirmation/reset-confirmation.component";
import { SignupActivateComponent } from "./signup-activate/signup-activate.component";
import { SignupComponent } from './signup/signup.component';
import { TermsOfServiceComponent } from './terms-of-service/terms-of-service.component';
import { WelcomeComponent } from "./welcome/welcome.component";

const automatedResponseRouteMatcher = (url: UrlSegment[]) => {
    return url.length > 0 && url[0].path.includes('automated-response') ? ({ consumed: url }) : null;
}

const connectionsRouteMatcher = (url: UrlSegment[]) => {
    return (url.length > 0 && (url[0].path.includes('integrations') || url[0].path.includes('connectors') || url[0].path.includes('connections'))) ? ({ consumed: url }) : null;
}

const routes: Routes = [
    {
        path: '',
        component: HomeRouteComponent,
        data: {
            title: "Accounts",
            hideMenus: true
        }
    },
    {
        path: 'access_token',
        component: HomeRouteComponent,
        canActivate: [AlIdentityResolutionGuard],
        data: {
            hideMenus: true
        }
    },
    {
        path: 'password/reset',
        component: InitiatePasswordResetComponent,
        data: {
            title: "Password Reset",
            hideMenus: true
        }
    },
    {
        path: 'password/reset/confirm',
        component: ResetConfirmationComponent,
        data: {
            title: "Password Reset",
            hideMenus: true
        }
    },
    {
        path: 'password/reset/confirm/:token',
        component: PasswordResetComponent,
        data: {
            title: "Password Reset",
            hideMenus: ɵbypassSanitizationTrustResourceUrl
        }
    },
    {
        path: 'signup/activate/:product/:token',
        component: SignupActivateComponent,
        data: {
            hideMenus: true,
            alNavigation: ['alNavigation.disableHeader']
        }
    },
    {
        path: 'login',
        component: LoginComponent,
        data: {
            hideMenus: true,
            title: "Login"
        }
    },
    {
        path: 'terms-of-service',
        component: TermsOfServiceComponent,
        data: {
            hideMenus: true,
            title: "Terms of Service"
        }
    },
    {
        path: 'logout',
        component: LogoutComponent,
        data: {
            title: "Logout",
            hideMenus: true
        }
    },
    {
        path: 'error/:errorType',
        component: GeneralErrorComponent,
        data: {
            title: "Error",
        }
    },
    {
        path: 'welcome',
        component: WelcomeComponent,
        canActivate: [AlIdentityResolutionGuard],
        data: {
            title: "Accounts"
        }
    },
    {
        path: 'signup/:awsToken/:product',
        component: SignupComponent,
        data: {
            title: "Sign Up",
            alNavigation: ['alNavigation.disableHeader']
        }
    },
    {
        path: 'support',
        loadChildren: () => import('../modules/support/support.module').then(m => m.SupportModule)
    },
    {
        path: 'aims',
        loadChildren: () => import('../modules/users/users.module').then(m => m.UsersModule)
    },
    {
        path: 'mfa',
        loadChildren: () => import('../modules/mfa/mfa.module').then(m => m.MFAModule)
    },
    {
        component: AlRedirectorComponent,
        matcher: connectionsRouteMatcher,
        data: {
            target: {
                location: AlLocation.MagmaUI,
                keepCurrentPath: true
            }
        }
    },
    {
        path: 'manage-notifications',
        loadChildren: () => import('../modules/manage-notifications/manage-notifications.module').then(m => m.ManageNotificationsModule)
    },
    {
        component: AlRedirectorComponent,
        matcher: automatedResponseRouteMatcher,
        data: {
            target: {
                location: AlLocation.MagmaUI,
                keepCurrentPath: true
            }
        }
    },
    {
        path: 'goto',
        loadChildren: () => import('../modules/goto/goto.module').then(m => m.GotoModule)
    },
    {
        path: '**',
        component: HomeRouteComponent
    }
];

export const routing = RouterModule.forRoot(routes, { useHash: true });
